import React, { useReducer, createContext, useContext } from 'react';
import PropTypes from 'prop-types';
import { store, timeDurationTools, magicNumbers } from 'utils';
import { isNull } from 'lib';

const { getStore } = store();

const cacheData = {
  set: (_state) => {
    const state = { ..._state };
    // حذف برخی از متغیر ها از کانتکست
    [
      'bulletinContentTabs',
      'bulletinContentTabsCounter',
      'layout',
      'posts',
      'selectedPost',
      'selectedSource',
      'tagsData',
      'filtersOpen',
      'resourceTagsData',
      'date',
      'pageTitle',
      'isQuote',
    ].forEach((key) => {
      delete state[key];
    });
    localStorage.setItem('cacheData', JSON.stringify(state));
  },
  get: () => {
    return JSON.parse(localStorage.getItem('cacheData'));
  },
};

const calculateTimeDurationAndFromDateAndToDate = (__siteSettings) => {
  if (__siteSettings?.timeFilter) {
    if (__siteSettings?.timeFilter?.timeDuration) {
      return {
        timeDuration: __siteSettings?.timeFilter?.timeDuration,
        fromDate: null,
        toDate: null,
      };
    }

    if (
      __siteSettings?.timeFilter?.fromDate &&
      __siteSettings?.timeFilter?.toDate
    ) {
      return {
        timeDuration: undefined,
        fromDate: __siteSettings?.timeFilter?.fromDate,
        toDate: __siteSettings?.timeFilter?.toDate,
      };
    }
  } else {
    return {
      timeDuration: __siteSettings?.timeDuration
        ? timeDurationTools(__siteSettings?.timeDuration).toNumber()
        : magicNumbers.ONE_WEEK_IN_SECONDS,
      fromDate: null,
      toDate: null,
    };
  }
};

const initialState = {
  // محتوای اصلی
  title: 'gpr-product',
  sidebarOpen: isNull(getStore('sidebarOpen')) ? true : getStore('sidebarOpen'),
  filtersOpen: isNull(getStore('filtersOpen'))
    ? false
    : getStore('filtersOpen'),
  q: undefined,
  totalCount: 0,
  pageTitle: '',
  menuKey: 'newsAndInformation',
  layout: {
    filters: {
      display: false,
    },
    date: {
      display: false,
    },
    dateTime: {
      display: false,
    },
    query: {
      display: false,
    },
  },
  // جزئیات محتوا
  isQuote: null,
  // فیلترهای سایدبار
  filtersConfig: {},
  filtersValue: {},
  filtersSelected: {},
  // فیلتر وضعیت کامنت اینستا: کامنت زیر پست مرتبط یا کامنت مرتبط با موضوع
  instagramCommentState: 'underPostRelatedToSubject',
  // فیلترهای مربوط به دسته بندی منابع
  rCFiltersConfig: {},
  rCFiltersValue: {},
  rCFiltersSelected: {},
  // فیلترهای مربوط به جست‌وجوی آزاد منابع
  resourceFiltersConfig: {},
  resourceFiltersValue: {},
  resourceFiltersSelected: {},
  // فیلترهای مربوط به آلارم
  alarmFiltersConfig: {},
  alarmFiltersValue: {},
  alarmFiltersSelected: {},
  // محتوای اصلی (مطالب)
  pageCount: 10,
  posts: [],
  selectedPost: [],
  selectedSource: [],
  news: {
    sort: 'time',
    sort_type: 'desc',
    source: 'both',
  },
  instagram_post: {
    sort: 'time',
    sort_type: 'desc',
  },
  instagram_comment: {
    sort: 'time',
    sort_type: 'desc',
  },
  twitter: {
    sort: 'time',
    sort_type: 'desc',
    source: 'original',
  },
  telegram: {
    sort: 'time',
    sort_type: 'desc',
    source: 'both',
  },
  newspaper: {
    sort: 'time',
    sort_type: 'desc',
  },
  media_type: undefined,
  // محتوای بولتن
  bulletinContent: [],
  selectAllBulletinContent: [],
  selectedBulletinContentPlatform: 'news',
  changedBulletinSort: false,
  bulletinContentTabs: {},
  bulletinContentTabsCounter: {},
  // فیلترهای اصلی
  queryId: undefined,
  fromDate: undefined,
  toDate: undefined,
  date: undefined,
  timeDuration: cacheData.get()?.['fromDate']
    ? undefined
    : magicNumbers.ONE_WEEK_IN_SECONDS,
  // آمارها و نمودار ها
  forceUpdate: 0,
  // اعلان‌ها
  notifications: [],
  unseenNotifications: 0,
  // دیتا ها
  tagsData: [],
  // نسخه های جدید سامانه
  newVersion: undefined,
  // ساخت آلارم
  alarmConfigs: {
    type: 'contents',
    settings: 'alarm_selected_subject',
    resource: {
      platforms: ['news', 'instagram', 'twitter', 'telegram'],
    },
    advanced_filters: {
      subject: 'all',
      global: {
        advertisement: false,
        source: false,
      },
    },
    contents: {
      selectedPlatform: 'news',
    },
    environment: {
      type: 'telegram',
      value: '',
    },
    global: {
      evryday: true,
      title: '',
      time: '12',
    },
  },
  // بولتن اتومات
  smartBulletinConfigs: {
    resource: {
      platforms: [],
      // در اینده اگر لازم شد جزئیات هر پلتفرم مثل موضوع و زمان و تعداد و غیره متفاوت باشه اینجا ذخیره بشن
    },
    advanced_filters: {
      global: {
        advertisement: false,
        source: false,
      },
    },
    global: {
      title: '',
      suffix_type: 'date',
      days: {},
      creation_hour: magicNumbers.SMART_BULLETIN_DEFAULT_HOUR,
      time_type: 1,
      time_count: '',
      count: '',
      sort: 'relation.influence',
      sort_type: 'DESC',
      query: '',
      autoContentSubmission: true,
      step: 'step1',
    },
  },
  vipResourceList: [],
  isNotResourceId: true,
  ...cacheData.get(),
  ...calculateTimeDurationAndFromDateAndToDate(
    cacheData.get()?.['siteSettings']
  ),
};

const stateContext = createContext(undefined);
const dispatchContext = createContext(undefined);

const reducer = (state, action) => {
  let _allState = null;
  switch (action.type) {
    case 'setPageConfig':
      _allState = {
        ...state,
        pageTitle: action.value,
        pageHeader: action.pageHeader,
        menuKey: action.menuKey,
        minDate: action.minDate,
        sort: 'time',
        sort_type: 'desc',
        resource_sort: 'influence',
        date: action.date,
        layout: {
          ...state?.layout,
          filters: {
            ...state?.layout?.filters,
            display: action.displayFilters !== false,
          },
          dateTime: {
            ...state?.layout?.dateTime,
            display: action.displayDateTime !== false,
          },
          date: {
            ...state?.layout?.date,
            display: action.displayDate !== false,
          },
          query: {
            ...state?.layout?.query,
            display: action.displayQuery !== false,
          },
        },
      };
      cacheData.set(_allState);
      return _allState;

    default: {
      const obj = {};
      let isCache = false;
      Object.keys(action).forEach((key) => {
        if (!['type', 'cache'].includes(key)) {
          obj[key] = action[key];
        } else if (key === 'cache') {
          isCache = true;
        }
      });
      _allState = {
        ...state,
        ...obj,
      };
      if (isCache) {
        cacheData.set(_allState);
      }
      return _allState;
    }
    // default:
    //   throw new Error(`Unexpected action: ${action.type}`);
  }
};

const Provider = ({ children }) => {
  const [state, dispatchState] = useReducer(reducer, initialState);
  return (
    <stateContext.Provider value={state}>
      <dispatchContext.Provider value={dispatchState}>
        {children}
      </dispatchContext.Provider>
    </stateContext.Provider>
  );
};

Provider.propTypes = {
  children: PropTypes.node,
};

const useStateContext = () => {
  return useContext(stateContext);
};
const useDispatchContext = () => {
  return useContext(dispatchContext);
};

export { Provider, useStateContext, useDispatchContext, initialState };
